import { useState, useEffect } from 'react';
import styled, { css, useTheme } from 'styled-components';
import getSpacing from '~/helpers/getSpacing';
import EditButton from '../../atoms/EditButton';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  margin: ${({ offsetTop }) => offsetTop}px auto 0;

  ${(props) => getSpacing(props.spacing, 'mbottom')}

  ${(props) =>
    ['CONTENT_HUB_HERO', 'HERO_STAGE'].includes(
      props?.['data-module-name'] ? props['data-module-name'] : '',
    ) &&
    css`
      place-content: center;
      margin: 0;
    `}

  ${(props) =>
    props.btnIsHovered &&
    css`
      outline: 5px dashed
        ${props.theme.color[props.theme.editButton.backgroundColor]};
    `}
`;

const EditButtonStyled = styled(EditButton)`
  position: absolute;
  top: ${(props) => (props.withTopOffset ? '-45px' : '0')};
  right: 0;
`;

/**
 * @param {CmsElmProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CmsElmWrapper = ({
  spacing,
  elementName,
  hasFadeIn,
  editMode,
  children,
  id,
  className,
  offsetTop = 0,
}) => {
  const [btnIsHovered, setBtnHoverState] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            entry.target.classList.remove('waiting-for-fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -25% 0px' },
    );

    const elements = document.querySelectorAll('.waiting-for-fade-in');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const fadeClass = hasFadeIn && !editMode ? 'waiting-for-fade-in' : '';

  const { exceptionList } = theme.editButton;
  let withTopOffset = false;

  if (elementName) {
    withTopOffset = exceptionList.indexOf(elementName) !== -1;
  }

  return (
    <Wrapper
      spacing={spacing}
      id={id}
      data-id="cms-elm-wrapper"
      btnIsHovered={btnIsHovered}
      className={`${fadeClass} ${className}`}
      data-module-name={elementName}
      offsetTop={offsetTop}
    >
      {editMode && (
        <EditButtonStyled
          href={editMode.link}
          text={editMode.text}
          withTopOffset={withTopOffset}
          onHover={(val) => setBtnHoverState(val)}
        />
      )}
      {children}
    </Wrapper>
  );
};

export default CmsElmWrapper;
